var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomTypedEvent, CustomElement, Watch, ViewChild, Defaults, PCSS, P, Components, PropertyConverters, Utils, avoidHandler, Logging, CustomElementUtils } from '@pacem/pacem-core';
import { Components as ComponentsUI } from '@pacem/pacem-ui';
import { PacemDataSourceElement } from './types-components';
//namespace Pacem.Components.Scaffolding {
class SuggestionSelectEvent extends CustomTypedEvent {
    constructor(value) {
        super('suggestionselect', { selectedValue: value });
    }
}
const BALLOON_POPUP_DELAY = 100;
const BALLOON_POPOUT_DELAY = 0;
let PacemSuggestElement = class PacemSuggestElement extends PacemDataSourceElement {
    constructor() {
        super(...arguments);
        this._toggleBtnHandler = (evt) => {
            evt.preventDefault();
            if (!this.disabled) {
                this._balloon.toggle();
            }
        };
        this._clearBtnHandler = (evt) => {
            evt.preventDefault();
            this.hint = this._input.value = '';
            this.value = void 0;
            this._focus(null);
            this.changeHandler(new SuggestionSelectEvent(null));
        };
        this._balloonPopupHandler = (evt) => {
            Utils.addClass(this._btnArrow, 'rotate-180');
        };
        this._balloonPopoutHandler = (evt) => {
            Utils.removeClass(this._btnArrow, 'rotate-180');
        };
        this._inputHandler = (evt) => {
            switch (evt.keyCode) {
                case 9 /*tab*/:
                case 13 /*enter*/:
                    break;
                default:
                    this._focus(null);
                    this.hint = this._input.value;
                    this.changeHandler(new SuggestionSelectEvent(null));
                    break;
            }
        };
        this._keyupHandler = (evt) => {
            if (this.#keyupManaged) {
                avoidHandler(evt);
                this.#keyupManaged = false;
            }
        };
        this._focusHandler = (evt) => {
            if (this.preventFocus) {
                // manage the balloon toggle manually (since focus won't be dispatched)
                evt.preventDefault();
                const balloon = this._balloon;
                if (!balloon.visible) {
                    this.popup();
                }
                else {
                    this.popout();
                }
            }
            const actualHint = this._input.value;
            if (this.viewValue != actualHint) {
                this._databind();
            }
            // now just lean on the balloon's trigger, it will popup eventually...
        };
        this._blurHandler = (evt) => {
            this._undo();
        };
        this.#keyupManaged = false;
        this._keydownHandler = (evt) => {
            var managed = false;
            if (Utils.isNull(this.#selectedItem)) {
                const el = this._findFirstAvailableListItem();
                if (!Utils.isNull(el)) {
                    switch (evt.keyCode) {
                        case 40: /*arrow down*/
                            //case 9: /*tab*/
                            //case 13: /* enter */                        
                            avoidHandler(evt);
                            this._focus(el);
                            break;
                        case 13: /* enter */
                            avoidHandler(evt);
                            managed = true;
                            if (this.#datasource.length === 1) {
                                this._select(el);
                            }
                            else {
                                this._focus(el);
                            }
                            break;
                    }
                }
            }
            else {
                var li = this.#selectedItem, cursor = li, target;
                const skipPredicate = (e) => !Utils.isNull(e) && e.localName === 'li' && e.dataset['pacemDisabled'] === 'true', matchPredicate = (e) => !Utils.isNull(e) && e.localName === 'li' && e.dataset['pacemDisabled'] !== 'true';
                switch (evt.keyCode) {
                    case 38 /*arrow up*/:
                        avoidHandler(evt);
                        do {
                            cursor = cursor.previousElementSibling;
                            if (matchPredicate(cursor)) {
                                target = cursor;
                                break;
                            }
                        } while (skipPredicate(cursor));
                        target ??= li;
                        break;
                    case 40 /*arrow down*/:
                        avoidHandler(evt);
                        do {
                            cursor = (cursor.nextElementSibling);
                            if (matchPredicate(cursor)) {
                                target = cursor;
                                break;
                            }
                        } while (skipPredicate(cursor));
                        target ??= li;
                        break;
                    case 27 /*esc*/:
                        avoidHandler(evt);
                        this._undo();
                        this.popout();
                        break;
                    case 9 /*tab*/:
                    case 13 /*enter*/:
                        // case 32 /*space-bar*/:
                        avoidHandler(evt);
                        managed = true;
                        this._select();
                        break;
                }
                this._focus(target);
                this.#keyupManaged = managed;
            }
        };
        this._selectHandler = (evt) => {
            avoidHandler(evt);
            this._select(evt.currentTarget);
        };
    }
    get inputFields() {
        return [this._input];
    }
    acceptValue(val) {
        if ( /*!this._isTyping && */(this.allowNew || !Utils.isNullOrEmpty(this.datasource))) {
            this._input.value = this.getViewValue(val) || (this._isTyping ? this._input.value : '');
        }
    }
    getViewValue(val) {
        var superValue = super.getViewValue(val);
        if (Utils.isNullOrEmpty(superValue) && this.allowNew && !Utils.isNullOrEmpty(val)) {
            superValue = this.mapEntityToViewValue(val);
        }
        return superValue;
    }
    onChange(evt) {
        return new Promise((resolve, reject) => {
            // change triggered elsewhere... (see _afterSelectHandler)
            if (evt.type === 'suggestionselect') {
                const val = evt.detail.selectedValue;
                this.value = val;
                if (val) {
                    this.popout();
                }
                resolve(val);
            }
            else {
                // keep the current value
                resolve(this.value);
            }
        });
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._setDropdownMode();
        this._setupItemTemplate();
        var balloon = this._createBalloon();
        balloon.appendChild(this._repeater);
        this._checkBalloon(balloon);
        const shell = CustomElementUtils.findAncestorShell(this);
        shell.appendChild(balloon);
        this._balloon = balloon;
        this._input.addEventListener('mousedown', this._focusHandler, false);
        this._input.addEventListener('keydown', this._keydownHandler, false);
        this._input.addEventListener('keyup', this._keyupHandler, false);
        this._input.addEventListener('focus', this._focusHandler, false);
        this._input.addEventListener('blur', this._blurHandler, false);
        this._input.addEventListener('input', this._inputHandler, false);
        this._btnClear.addEventListener('mousedown', this._clearBtnHandler, false);
        this._btnArrow.addEventListener('mousedown', this._toggleBtnHandler, false);
        this._databind();
        this._syncButtons();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (Utils.isNull(this._balloon)) {
            return;
        }
        const typing = this._isTyping;
        switch (name) {
            case 'adaptedDatasource':
                if (!Utils.isNullOrEmpty(val)) {
                    if (!typing) {
                        this._input.value = this.getViewValue(this.value);
                    }
                    else {
                        this.popup();
                    }
                }
                else {
                    this.popout();
                }
                break;
            case 'hint':
                if (!typing && val !== this._input.value) {
                    this._input.value = val;
                    this.#selectedItem = null;
                }
                break;
            case 'readonly':
                // overrides default behavior: attribute synchronization (see `PacemBaseElement` in types.ts)
                this._setDropdownMode();
            // then fall below
            case 'disabled':
            case 'value':
                this._checkBalloon();
                break;
            case 'itemtemplate':
                if (!first) {
                    this._setupItemTemplate();
                }
                break;
            case 'allowTyping':
                if (!first) {
                    this._setDropdownMode();
                }
                break;
        }
        if (['adaptedDatasource', 'hint', 'value'].indexOf(name) >= 0) {
            this._databind();
        }
        if (['allowTyping', 'value', 'hint'].indexOf(name) >= 0) {
            this._syncButtons();
        }
    }
    disconnectedCallback() {
        if (!Utils.isNull(this._balloon)) {
            this._balloon.removeEventListener('popup', this._balloonPopupHandler, false);
            this._balloon.removeEventListener('popout', this._balloonPopoutHandler, false);
            this._balloon.remove();
        }
        if (!Utils.isNull(this._input)) {
            this._input.removeEventListener('mousedown', this._focusHandler, false);
            this._input.removeEventListener('focus', this._focusHandler, false);
            this._input.removeEventListener('blur', this._blurHandler, false);
            this._input.removeEventListener('keydown', this._keydownHandler, false);
            this._input.removeEventListener('keyup', this._keyupHandler, false);
            this._input.removeEventListener('input', this._inputHandler, false);
        }
        if (!Utils.isNull(this._btnClear)) {
            this._btnClear.removeEventListener('mousedown', this._clearBtnHandler, false);
        }
        if (!Utils.isNull(this._btnArrow)) {
            this._btnArrow.addEventListener('mousedown', this._toggleBtnHandler, false);
        }
        super.disconnectedCallback();
    }
    #datasource;
    _databind() {
        if (!Utils.isNull(this._repeater)) {
            const ds = this.#datasource = this._filter(this.adaptedDatasource, this._input.value);
            this._repeater.datasource = ds;
        }
    }
    _syncButtons() {
        if (!Utils.isNull(this._btnArrow)) {
            // hide="{{ !$pacem.isNullOrEmpty(:host.hint || :host.value) || :host.allowTyping !== false }}"
            this._btnArrow.hide = this.allowTyping !== false || !Utils.isNullOrEmpty(this._input.value || this.value);
        }
        if (!Utils.isNull(this._btnClear)) {
            //  hide="{{ $pacem.isNullOrEmpty(:host.hint || :host.value) }}"
            this._btnClear.hide = this.readonly || Utils.isNullOrEmpty(this._input.value || this.value);
        }
    }
    get _isTyping() {
        return Utils.is(this._input, ':focus'); // && this.viewValue !== this._input.value;
    }
    _undo() {
        this._focus(null);
        this.hint = this._input.value = this.getViewValue(this.value) || '';
    }
    _findFirstAvailableListItem() {
        var el;
        if (this._balloon.visible === true && !Utils.isNull(el = this._repeater.querySelector('ol > li'))) {
            while (!Utils.isNull(el) && el.dataset['pacemDisabled'] === 'true' && el.localName === 'li') {
                el = el.nextElementSibling;
            }
        }
        return el;
    }
    #keyupManaged;
    _setDropdownMode(allowTyping = this.allowTyping) {
        this._input.readOnly = !(allowTyping ?? true);
    }
    _setupItemTemplate() {
        if (this.itemtemplate instanceof HTMLTemplateElement) {
            const frag = this.itemtemplate.cloneNode(true).content;
            const tmpl = document.createElement('template');
            const li = document.createElement('li');
            li.append(frag);
            tmpl.content.appendChild(li);
            this._tmplProxy.target = tmpl;
        }
        else {
            this._tmplProxy.target = this._defaultTemplate;
        }
    }
    #selectedItem;
    _focus(el) {
        if (this.preventFocus) {
            return;
        }
        if (Utils.isNull(el)) {
            this.#selectedItem = null;
            return;
        }
        const siblings = el.parentElement.children;
        for (let j = 0; j < siblings.length; j++) {
            const item = siblings.item(j);
            if (item === el) {
                item.dataset['pacemFocused'] = 'true';
                this.#selectedItem = item;
                const input = this._input, viewValue = input.value = JSON.parse(item.dataset['pacemViewValue']);
                input.setSelectionRange(viewValue.length, viewValue.length);
            }
            else {
                delete item.dataset['pacemFocused'];
            }
        }
    }
    _select(el = this.#selectedItem) {
        const value = JSON.parse(el.dataset['pacemValue']), disabled = el.dataset['pacemDisabled'] === 'true';
        if (!disabled) {
            this.changeHandler(new SuggestionSelectEvent(value));
        }
    }
    _filter(ds, hint, value = this.value) {
        let datasource = ds || [];
        //if (!Utils.isNull(value)) {
        //    datasource = datasource.filter(i => i.value == value);
        //} else 
        if (!Utils.isNullOrEmpty(hint && hint.trim())) {
            const lowerHints = hint.toLowerCase().split(' ');
            let filtered = datasource.filter(i => {
                for (let lowerHint of lowerHints) {
                    if (i.viewValue?.toLowerCase().indexOf(lowerHint) >= 0) {
                        return true;
                    }
                    // check the whole 'data' object, just in case
                    const filters = this.filterFields;
                    if (!Utils.isNullOrEmpty(filters)) {
                        const iData = i.data;
                        if (typeof iData === 'object' && !Utils.isNullOrEmpty(iData)) {
                            for (let filter of filters) {
                                const filterStruct = filter.split('.');
                                let j = 0;
                                let value = iData;
                                while (!Utils.isNull(value) && j < filterStruct.length) {
                                    value = value[filterStruct[j]];
                                    j++;
                                }
                                if (Utils.isNullOrEmpty(value)) {
                                    continue;
                                }
                                if (value.toString().toLowerCase().indexOf(lowerHint) >= 0) {
                                    return true;
                                }
                            }
                        }
                    }
                }
                return false;
            });
            const concatenate = this.allowNew
                // only concatenate on plain strings...
                && Utils.isNullOrEmpty(this.valueProperty)
                && Utils.isNullOrEmpty(this.textProperty)
                // ...and no matches are available
                && (Utils.isNullOrEmpty(filtered) || Utils.isNull(filtered.find(i => i.viewValue === hint)));
            datasource = concatenate ? [{ value: hint, viewValue: hint, data: hint }].concat(filtered) : filtered;
        }
        let retval = datasource;
        if (this.allowTyping !== false) {
            // max-suggestions enabled only when typing is allowed (default)
            retval = datasource.slice(0, this.maxSuggestions || 10);
        }
        //
        if (this._isTyping) {
            this.popup();
        }
        this._balloon.style.opacity = Utils.isNullOrEmpty(retval) ? '0' : '';
        this.log(Logging.LogLevel.Log, `${retval.length} dropdown suggestion(s), given hint '${hint}' and ${(ds || []).length} datasource items`);
        return retval;
    }
    _itemCreate(evt) {
        const li = evt.detail.dom.find(i => i instanceof HTMLLIElement);
        const item = evt.detail.item;
        const index = evt.detail.index;
        const disabled = item.disabled === true;
        li.tabIndex = disabled ? -1 : 0;
        li.dataset['pacemValue'] = JSON.stringify(item.value);
        li.dataset['pacemViewValue'] = JSON.stringify(item.viewValue);
        li.dataset['pacemDisabled'] = disabled.toString();
        li.addEventListener('mousedown', this._selectHandler, false);
    }
    _itemRemove(evt) {
        const li = evt.detail.dom.find(i => i instanceof HTMLLIElement);
        li.removeEventListener('mousedown', this._selectHandler, false);
    }
    toggleReadonlyView(readonly) {
        this.span.hidden = !readonly;
        this._input.hidden = readonly;
        if (readonly) {
            this._btnClear.hide = this._btnArrow.hide = true;
        }
        else {
            this._syncButtons();
        }
    }
    /*
    Balloon and repeater
    */
    popup(delay = BALLOON_POPUP_DELAY) {
        if (!Utils.isNullOrEmpty(this.adaptedDatasource) && Utils.isVisible(this)) {
            //console.log('Popping up from here...');
            this._balloon?.popup(delay);
        }
    }
    popout(delay = BALLOON_POPOUT_DELAY) {
        this.#selectedItem = null;
        this._balloon?.popout(delay);
    }
    _checkBalloon(balloon = this._balloon) {
        if (!Utils.isNull(balloon)) {
            const hasValue = !Utils.isNullOrEmpty(this.value) && !Utils.isNullOrEmpty(this._input.value) /* && Utils.isNullOrEmpty(this.hint)*/;
            balloon.disabled = hasValue || this.readonly || this.disabled || /* normalize to an actual boolean */ false; // || Pacem.Utils.isNullOrEmpty(this.adaptedDatasource);
        }
    }
    _createBalloon() {
        /*<${ P }-balloon target="{{ ::_input }}" options="{ position: 'bottom', align: 'left', behavior: 'inert', hoverDelay: 0 }"
disabled="{{ :host.readonly || Pacem.Utils.isNullOrEmpty(:host.adaptedDatasource) }}">*/
        const balloon = document.createElement(P + '-balloon');
        Utils.addClass(balloon, 'suggest dropdown');
        balloon.options = {
            trackPosition: true,
            trigger: ComponentsUI.UI.BalloonTrigger.Focus,
            position: ComponentsUI.UI.BalloonPosition.VerticalAuto,
            size: ComponentsUI.UI.BalloonSizing.Match,
            align: ComponentsUI.UI.BalloonAlignment.Start,
            behavior: ComponentsUI.UI.BalloonBehavior.Menu, // UI.BalloonBehavior.Inert,
            hoverDelay: BALLOON_POPUP_DELAY, hoverTimeout: BALLOON_POPOUT_DELAY
        };
        balloon.addEventListener('popup', this._balloonPopupHandler, false);
        balloon.addEventListener('popout', this._balloonPopoutHandler, false);
        balloon.target = this._input;
        return balloon;
    }
};
__decorate([
    ViewChild('input[type=text]')
], PacemSuggestElement.prototype, "_input", void 0);
__decorate([
    ViewChild(P + '-repeater')
], PacemSuggestElement.prototype, "_repeater", void 0);
__decorate([
    ViewChild(`span.${PCSS}-readonly`)
], PacemSuggestElement.prototype, "span", void 0);
__decorate([
    ViewChild(`template`)
], PacemSuggestElement.prototype, "_defaultTemplate", void 0);
__decorate([
    ViewChild(P + '-template-proxy')
], PacemSuggestElement.prototype, "_tmplProxy", void 0);
__decorate([
    ViewChild(`${P}-button[toggle]`)
], PacemSuggestElement.prototype, "_btnArrow", void 0);
__decorate([
    ViewChild(`${P}-button[clear]`)
], PacemSuggestElement.prototype, "_btnClear", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemSuggestElement.prototype, "hint", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemSuggestElement.prototype, "maxSuggestions", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemSuggestElement.prototype, "allowTyping", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemSuggestElement.prototype, "preventFocus", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Element })
], PacemSuggestElement.prototype, "itemtemplate", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.StringArray })
], PacemSuggestElement.prototype, "filterFields", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemSuggestElement.prototype, "allowNew", void 0);
PacemSuggestElement = __decorate([
    CustomElement({
        tagName: P + '-suggest', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<div class="${PCSS}-relative"><input type="text" class="${PCSS}-input" />
<${P}-button clear tab-order="-1"
class="button-flat ${PCSS}-anim anim-pop anim-sudden anim-quick pos-absolute absolute-right absolute-top display-block ${PCSS}-margin margin-0" 
    icon-glyph="highlight_off"></${P}-button>
<${P}-button 
class="button-flat icon-rotate ${PCSS}-anim anim-pop anim-sudden anim-quick pos-absolute absolute-right absolute-top display-block ${PCSS}-margin margin-0" 
    icon-glyph="arrow_drop_down" tab-order="-1" toggle></${P}-button>
</div>
<span class="${PCSS}-readonly"><${P}-text text="{{ :host.viewValue }}"></${P}-text></span>
<${P}-repeater on-${Components.RepeaterItemCreateEventName}=":host._itemCreate($event)" on-${Components.RepeaterItemRemoveEventName}=":host._itemRemove($event)">
    <ol>
        <${P}-template-proxy></${P}-template-proxy>
    </ol>
</${P}-repeater><${P}-content></${P}-content>
<template>
    <li><${P}-span content="{{ $pacem.highlight(^item.viewValue, :host.hint) }}"></${P}-span></li>
</template>`
    })
], PacemSuggestElement);
export { PacemSuggestElement };
